const getLatLng = (result) => (
  new Promise((resolve, reject) => {
    try {
      const latLng = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng(),
      };
      return resolve(latLng);
    } catch (e) {
      return reject(e);
    }
  })
);

const geocodeByAddress = (address) => {
  const geocoder = new window.google.maps.Geocoder();
  const { OK } = window.google.maps.GeocoderStatus;

  return new Promise((resolve, reject) => {
    geocoder.geocode(
      { address },
      (
        results,
        status,
      ) => {
        if (status !== OK) {
          return reject(status);
        }

        return resolve(results);
      });
  });
};

const parseAddressComponents = (addressComponents) => {
  const parts = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const component of addressComponents) {
    const { long_name: longName, types } = component;
    // eslint-disable-next-line no-restricted-syntax
    for (const type of types) {
      parts[type] = longName;

      if (type === 'administrative_area_level_1') {
        parts.administrative_area_level_1_short = component.short_name;
      }
    }
  }

  return parts;
};

const parseGooglePlace = (place) => {
  const {
    place_id: placeId,
    name,
    url: mapUrl,
    formatted_address: formattedAddress,
    address_components: addressComponents,
    geometry,
  } = place;

  const addressParts = addressComponents ? parseAddressComponents(addressComponents) : {};
  const lat = geometry ? geometry.location.lat() : null;
  const lng = geometry ? geometry.location.lng() : null;

  const parsed = {
    placeId,
    data: JSON.stringify(place),
    name,
    mapUrl,
    formattedAddress,
    latitude: lat,
    longitude: lng,
    city: addressParts.locality ? addressParts.locality : addressParts.administrative_area_level_3 ?? null,
    ...addressParts,
  };

  return parsed;
};

export { getLatLng, geocodeByAddress, parseAddressComponents, parseGooglePlace };
